import Alpine from "alpinejs";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

Alpine.data('TabbedContent', (sectionId) => ({
    activeTab: null,
    tabMenu: null,
    tabs: null,
    init(){
        this.tabMenu = this.$refs.tab_menu;

        this.tabs = this.tabMenu.children;
        this.activeTab = this.tabs[0].id;

        this.setActiveTab();

        let prevBtn = this.$refs.swiper_btn_prev;
        let nextBtn = this.$refs.swiper_btn_next;

        let swiper = new Swiper(this.$refs.tab_swiper, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            modules: [Navigation],
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            centeredSlides: true,
            breakpoints: {
                768: {
                    centeredSlides: false
                }
            }
        });
        this.bindEvents();
    },

    bindEvents(){
        window.addEventListener('hashchange', this.setActiveTab.bind(this))
    },

    setActiveTab(){
        const urlHash = window.location.hash;

        if(urlHash){
            const matchingTab = this.$el.querySelector(urlHash);
            
            if(matchingTab){
                this.activeTab = matchingTab.id;
            }
        }
    }

}));